import { getAxiosClient } from "../../HttpsService";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { WebApi } from "./web-api-interface";

export const fetchWebApiByAppUuid = createAsyncThunk(
  "webApi/fetchWebApiByAppUuid",
  async (appUuid: string) => {
    const client = getAxiosClient();
    const response = await client.get(`api/webapi/application/${appUuid}`);
    return response.data as WebApi[];
  }
);

export const fetchWebApiByUuid = createAsyncThunk(
  "webApi/fetchWebApiByUuid",
  async (id: string) => {
    const client = getAxiosClient();
    const response = await client.get(`api/webapi/${id}`);
    return response.data as WebApi;
  }
);

export const createWebApi = createAsyncThunk(
  "webApi/createWebApi",
  async (data: { appUuid: string; name: string }) => {
    const client = getAxiosClient();
    const response = await client.post("api/webapi", {
      appUuid: data.appUuid,
      apiNm: data.name,
      apiDesc: "",
    });
    return response.data as WebApi;
  }
);
